import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RoleDetail } from '../../signing-page/signing-page.dto';
import Pusher from 'pusher-js';
import { GlobalService } from 'app/global/global.service';
import { TranslocoService } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationTypeEnum } from '../../enums/enum';
import { AbstractSigningPageComponent } from '../../signing-page/abstract-signing-page.component';
import { EditorEmitterService } from 'app/main/pages/events/editor-emitter.service';
import { SingingPageService } from '../../signing-page/signing-page-service';
import { DeletedAttachment } from 'app/main/pages/events/editor-emitter.dto';
import { Subject, takeUntil } from 'rxjs';
import { CriiptioBankService } from 'app/bankid/criiptio-bank.service';

@Component({
  selector: 'app-norwegian-bank-id-box',
  templateUrl: './norwegian-bank-id-box.component.html',
  styleUrl: './norwegian-bank-id-box.component.scss'
})
export class NorwegianBankIdBoxComponent extends AbstractSigningPageComponent implements OnInit, OnDestroy{
  @Input() roleDetail: RoleDetail;
  public pusherRef: Pusher;
  public popupWindow;
  public authenticationTypeEnum = AuthenticationTypeEnum;
  private destroyed = new Subject<void>();
  private deletedAttachment:DeletedAttachment[] = [];
  constructor(
    public globalService: GlobalService,
    private _translocoService: TranslocoService,
    private modal: NgbModal,
    protected singingPage: SingingPageService,
    private editorEmitter: EditorEmitterService,
    private criiptioBankService:CriiptioBankService
    ) {
      super(singingPage, globalService, modal)
    }

  ngOnInit(): void {
    this.editorEmitter.deleteAttachment.pipe(takeUntil(this.destroyed)).subscribe({
      next : (attachment:DeletedAttachment) => {
        this.deletedAttachment = this.deletedAttachment.concat(attachment);
      }
    });
    this.criiptioBankService.subscribeToBankId(this.roleDetail);
    
    this.criiptioBankService.getBankIdSuccess$().pipe(takeUntil(this.destroyed)).subscribe({
      next: (params) => {
        this.readyToSignDocument(params);
      }
    });
  }

  processNorwegianBankId($event: Event){   
    $event.preventDefault(); 
    this.criiptioBankService.authenticate(this.roleDetail);
  }

   /**
   * open the sign document modal when bankid success
   */
  readyToSignDocument(data){
    this.signTheDocument(this.roleDetail.id, '', '', data, this.roleDetail, this.deletedAttachment, this.globalService.fields_data);
  }

  get currentAuthDetails() {
    switch (this.roleDetail?.authentication_type) {
      case this.authenticationTypeEnum.NORWEGIANBANKID:
        return {
          name: 'Norwegian BankID',
          header: 'Bankid box label for Norwegian bankid (Signing page - section) - Sign document with Norwegian BankID',
          boxLabelTranslation: 'Bankid box label for recipient (Signing page - section) - please complete your signature using Norwegian BankID',
          button: 'Bankid button text (Signing page - section) - Sign with BankID',
          description: 'Norwegian bankid card description (Signing page - section) - Sign with Norwegian BankID',
          logo: '../../assets/images/icons/norwegianbankidLogo.svg',
        };
      case this.authenticationTypeEnum.DANISHMITID:
        return {
          name: 'Danish MitID',
          header: 'Danish MitID box label (Signing page - section) - Sign document with Danish MitID',
          boxLabelTranslation: 'Danish MitID box label for recipient (Signing page - section) - please complete your signature using Danish MitID',
          button: 'Sign with text (Signing page - section) - Sign with',
          description: 'Danish MitID card description (Signing page - section) - Sign with Danish MitID',
          logo: '../../assets/images/authentication-icons/mitId-logo-white.png',
          logoClass: 'mit-id-icon',
          logoWidth: '60px',
        };
      case this.authenticationTypeEnum.FINNISHBANKID:
        return {
          name: 'Finnish BankID',
          header: 'Finnish BankID box label (Signing page - section) - Sign document with Finnish BankID',
          boxLabelTranslation: 'Finnish BankID box label for recipient (Signing page - section) - please complete your signature using Finnish BankID',
          button: 'Bankid button text (Signing page - section) - Sign with BankID',
          description: 'Finnish BankID card description (Signing page - section) - Sign with Finnish BankID',
          logo: '../../assets/images/authentication-icons/finnish_bank_id.png',
          logoClass: 'mit-id-icon',
          logoWidth: '30px',
        };
      default:
        return null;
    }
  }


  ngOnDestroy(){
    this.destroyed.next();
    this.destroyed.complete();
  }
}
